<template>
    <div  style="background-color:#fff">
      <van-sticky :offset-top="0 " >
        <mini_head_top> </mini_head_top>
      </van-sticky>
      <van-row  type="flex"  justify="space-between" style="margin: auto; padding: auto; width: 100%;text-align: left">
        <van-row>
          <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
          <span style="font-size:16px;  font-weight:700">知识题库</span>
        </van-row>
        <el-link style="margin-right: 10px;" type="primary" @click.native="goHome()">主页 <i class= "el-icon-s-home"> </i></el-link>
      </van-row >
      <div style="height:calc(80vh - 40px);overflow: auto;">
        <van-list 
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
        <van-row>
          <van-col style="padding: 10px;"  :span ="12"  v-for = "(item, index ) in qmList" :key = "index" >
            <div style="background-color:#fff;cursor: pointer;">
              <van-image
              style="width: 100%; height: 140px ;  cursor: pointer; border-radius: 10px;"
              :src="item.coverImage"  @click="goSelfTest(item.id)"></van-image>
              <el-tag type="warning"   @click="goSelfTest(item.id)"  style="width:100%; text-align:center; font-size: 11px;">
                {{ item.moduleName }}
              </el-tag>
            </div>
          </van-col>
        </van-row>
      </van-list>
      </div>
    </div>
  </template>
  <script>
    import axios from  '@/api/axiosConfig'
    import mini_head_top from "@/mini_pages/mini_head_top"
    import {MESSAGE_DURATION } from  '@/api/constant'
    export default {
      name : 'mini_qm_list',
      data () {
        return {
          pageNo :0,
          totalPageSize : 0,
          type : "知识题库",
          qmList: [],
          loading: false,
          finished: false
        }
      },
      methods: {
        goSelfTest(id){
          this.$router.push( {path: '/mini_qb', query: { id: id}})
        },
        goHome(){
          this.$router.push({path:'/mini_index'})
        },
        viewNoticeOne(id){
          this.$router.push( {path: '/mini_view_editor', query: { id: id,fileType:'安全知识' }})
        },
        onSearch(){
          setTimeout(() => {
            this.qmListLoad(1)
          }, 200)
        },
        onLoad() {
          setTimeout(() => {
            this.qmListLoad( (this.pageNo  + 1))
          }, 200)
        },
        qmListLoad(pageNo){
          
          let url = "/bc/exa/qm/qmPage"
          let dat0 = {
            pageSize: 20,
            pageNo:pageNo,
            active:1,
            adminInfInvoke: false
          }
          axios.post(url, dat0).then((response) => {
     
            this.pageNo = pageNo
            if (response.data.code === 0) {
              let dat = response.data.data
              if(dat.data.length !== 0){
                  if(pageNo == 1){
                    this.qmList = [];
                  }
                  dat.data.forEach(t=>this.qmList.push(t))
                  if( dat.data.length < dat.pageSize ){
                    this.finished = true;
                  }
              } else {
                this.finished = true
                if(pageNo == 1){
                  this.$message({
                    showClose: true,
                    message: '未查询到安全知识题库信息！',
                    type: 'info',
                    duration: MESSAGE_DURATION
                  })
                }
                
              }
            }else{
              this.finished = true
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            }
            this.loading = false;
            }).catch((err)=>{
              //this.loading = false
              this.pageNo = pageNo -1
              this.loading = false;
              this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            });
        },
      },
      created(){
        //setTimeout(()=>{this.noticeListLoad(1),200})
      },
      components:{
        mini_head_top
      }
    }
  </script>
  
  <style lang="less" scoped>
      
  </style>
  


// WEBPACK FOOTER //
// src/mini_pages/mini_qm_list.vue